const STORAGE_KEY = 'eachjewelry.paymentSuccess';
const MAX_AGE_MS = 60 * 60 * 1000;

export function savePaymentSuccessContext(context) {
    if (!context || typeof sessionStorage === 'undefined') {
        return;
    }

    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            ...context,
            savedAt: Date.now(),
        }));
    } catch {
        // ignore quota / private mode
    }
}

export function loadPaymentSuccessContext() {
    if (typeof sessionStorage === 'undefined') {
        return null;
    }

    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
            return null;
        }

        const savedAt = Number(parsed.savedAt);
        if (Number.isFinite(savedAt) && Date.now() - savedAt > MAX_AGE_MS) {
            sessionStorage.removeItem(STORAGE_KEY);
            return null;
        }

        const { savedAt: _ignored, ...context } = parsed;
        return context;
    } catch {
        return null;
    }
}

export function clearPaymentSuccessContext() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}
